/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentReportQueryAssessmentName extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentReportQueryAssessmentName");
    }

    getFixupPrototypeFunction() { return AssessmentReportQueryAssessmentName.fixupPrototype; }

    static newInstance(model: Partial<AssessmentReportQueryAssessmentName>): AssessmentReportQueryAssessmentName {
        let obj = Object.assign(new AssessmentReportQueryAssessmentName(), model);
        AssessmentReportQueryAssessmentName.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentReportQueryAssessmentName>): AssessmentReportQueryAssessmentName {
        if (!model) return null;
        return AssessmentReportQueryAssessmentName.newInstance(<AssessmentReportQueryAssessmentName> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentReportQueryAssessmentName) {
        if (!obj) return;

        models.AssessmentReportQueryAssessmentName.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentReportQueryAssessmentName): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentReportQueryAssessmentName.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regular expression to match against Assessment name
     */
    assessment_name: string;

}
